module.exports = __webpack_public_path__ + "img/materials2.54d21eab.svg";